import React, {useState} from 'react';
import Importfile from "components/formcomponents/importfile";

const HostIdentityForm = ({hostIdentity, setHostIdentity}) => {
    const [titleFileR, setTitleFileR] = useState('')
    const [titleFileV, setTitleFileV] = useState('')

    const handleFileR = e => {
        e.preventDefault()
        setHostIdentity(prev => ({...prev, fileR: e.target.files[0]}))
        setTitleFileR(e.target.files[0].name)
    }

    const handleFileV = e => {
        setHostIdentity(prev => ({...prev, fileV: e.target.files[0]}))
        setTitleFileV(e.target.files[0].name)
    }

    const handleChange = e => {
        e.preventDefault()
        setHostIdentity(prev => ({...prev, [e.target.name]: e.target.value}))
    }

    return (
        <div className={'h-[600px] overflow-y-auto px-2'}>
            <div className={'flex flex-col gap-3'}>
                <p className="ft-sm font-medium text-gray-700 mb-2">
                    Veuillez fournir la pièce d'identité de l'hébergeant.
                </p>
                <form className={'flex flex-col gap-3'}>
                    <div>
                        <label className={'ft-sm font-medium text-gray-500'}>
                            Type de document
                        </label>
                        <select
                            name="type"
                            className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg"
                            onChange={handleChange}
                            value={hostIdentity.type}
                        >
                            <option value="">Sélectionner</option>
                            <option value="Passeport">Passeport</option>
                            <option value="CNI">Carte nationale d'identité</option>
                        </select>
                    </div>
                    <div>
                        <label className={'ft-sm font-medium text-gray-500'}>
                            Nationalité
                        </label>
                        <select
                            name="nationality"
                            className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg"
                            onChange={handleChange}
                            value={hostIdentity.nationality}
                        >
                            <option value="">Sélectionner</option>
                            <option value="UE">Nationalité européenne (UE, EEE, Suisse)</option>
                            <option value="NUE">Nationalité non européenne</option>
                        </select>
                    </div>
                </form>
                <Importfile
                    name={'Recto'}
                    titleFile={titleFileR}
                    change={handleFileR}
                />
                {hostIdentity.type === 'CNI' && (
                    <Importfile
                        name={'Verso'}
                        titleFile={titleFileV}
                        change={handleFileV}
                    />
                )}
            </div>
        </div>
    );
};

export default HostIdentityForm;
